<div class="container-productos">

    <p-table [value]="Productos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Codigo</th>
                <th>Producto</th>
                <th>Folio</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-producto>
            <tr>
                <td>{{producto.fechaAplicacion | date:'dd/MM/yyyy'}}</td>
                <td>{{producto.codigo}}</td>
                <td>{{producto.nomProducto}}</td>
                <td>{{producto.casoclinico.serie}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td colspan="5">
                    Sin Productos
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                No. Registros: {{totalItemsProductos}}, Total paginas {{totalPaginasProductos}}
            </div>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChangeProductos($event)" [first]="currentPageProductos.first"
            [rows]="currentPageProductos.rows" [totalRecords]="totalItemsProductos"></p-paginator>
    </div>

</div>